import Button from 'react-bootstrap/Button'
import React from "react";
import { FinancialAssistance } from '../../../../models/FinancialAssistance';
import { MoneyField, ShowIf, TextField, validateFields } from "../../../../shared/fields";
import { ISection, TableColumn } from "../../../../shared/table";
import { formatNumber, newGuid } from "../../../../shared/Utility";

export const financialAssistanceColumns: TableColumn<FinancialAssistance>[] = [
    { name: "Source", content: d => d.source },
    { name: "Purpose", content: d => d.purpose },
    { name: "Amount", content: d => "$" + formatNumber(d.amount || 0) }
];

export interface FinancialAssistanceDetailsProps {
    id: string
    model: FinancialAssistance
    onChange: { (v: FinancialAssistance, close: boolean): any }
    onClose: { (): any }
    onRemove: { (): any }
    importing: boolean
    preview?: boolean
}

export interface FinancialAssistanceDetailsState {
    model: FinancialAssistance
}

export class FinancialAssistanceDetails extends React.Component<FinancialAssistanceDetailsProps, FinancialAssistanceDetailsState> implements ISection {
    source: TextField
    purpose: TextField
    amount: MoneyField

    constructor(props: FinancialAssistanceDetailsProps) {
        super(props);

        let model: FinancialAssistance = this.props.model ? { ...this.props.model } : {
            id: newGuid(),
            source: '',
            purpose: '',
            amount: null,
            invalid: false
        };

        this.state = {
            model
        };
    }

    validate = (callback: { (res: boolean): any }) => {
        validateFields(res => callback(res),
            this.source,
            this.purpose,
            this.amount
        );
    }

    saveAndClose = (callback?: { (res: boolean): any }) => {
        this.validate(res => {
            if (res) {
                this.props.onChange(this.state.model, true);
            }
            callback && callback(res);
        });
    }

    componentDidMount() {
        if (this.props.importing) {
            this.validate(res => {
                var temp = { invalid: !res }
                this.props.onChange({ ...this.state.model, ...temp }, true);
            })
        }
        else {
            if (this.state.model.invalid) {
                this.validate(() => { });
            }
        }
    }

    onChange = (change: Partial<FinancialAssistance>, callback?: { (): any }) => {
        this.setState({
            model: { ...this.state.model, ...change }
        }, callback);
    }

    render() {
        let model = this.state.model;

        return <>
            <TextField ref={r => this.source = r}
                id={`${this.props.id}-source`}
                label="Financial source"
                value={model.source}
                onChange={source => this.onChange({ source })}
                required={true}
                maxLength={80}
                preview={this.props.preview}
            />
            <TextField ref={r => this.purpose = r}
                id={`${this.props.id}-purpose`}
                label="Purpose of grant or reimbursement"
                value={model.purpose}
                onChange={purpose => this.onChange({ purpose })}
                required={true}
                maxLength={80}
                preview={this.props.preview}
            />
            <MoneyField ref={r => this.amount = r}
                id={`${this.props.id}-amount`}
                label="Amount"
                value={model.amount}
                onChange={amount => this.onChange({ amount })}
                required={true}
                preview={this.props.preview}
            />

            <ShowIf condition={!this.props.preview} className="clearfix mt-3">
                <Button className="emdg-btn float-right" onClick={e => this.saveAndClose()}>Complete row</Button>
                <Button  className="emdg-btn emdg-btn--secondary float-left mr-2" onClick={this.props.onClose} >Cancel</Button>
                <Button  className="emdg-btn emdg-btn--secondary float-left" onClick={this.props.onRemove} style={{ display: this.props.model ? "" : "none" }}>Remove</Button>
            </ShowIf>
        </>
    }
}